var map = {
	"./boss.png": "f88f",
	"./bossChest.png": "b0d0",
	"./chest.png": "7329",
	"./elite.png": "0a28",
	"./monster.png": "6962",
	"./rest.png": "c241",
	"./shop.png": "2710",
	"./unknown.png": "bba7",
	"./unknownChest.png": "9a20",
	"./unknownMonster.png": "61a2",
	"./unknownShop.png": "e5fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f462";